module.exports = __webpack_public_path__ + "static/img/后台-logo1.18fe1fa7.png";